import React from "react";
import "./ContactUs.css";

const ContactUs = () => {
   const handleEmailClick = () => {
  
  window.open(
    "https://mail.google.com/mail/?view=cm&fs=1&to=support@sattawalaonline.com&su=Support%20Inquiry&body=Hello%20Sattawala%20Team,",
    "_blank"
  );
  };
  return (
    <div className="contactus-container">
      <div className="contactus-header">
        <h1>Contact Us</h1>
        <p>We’re here to help you with Satta Wala queries & updates</p>
      </div>

      <div className="contactus-content">
        <section className="contactus-info">
          <h2>Get in Touch</h2>
          <p>
            Have questions about <strong>Satta Wala</strong> or need assistance?  
            Our team is here to provide support, share information, and guide you 
            regarding results & updates.
          </p>
          <ul>
            <li>📞 Phone / WhatsApp: <a style={{color:'#000',textDecoration:'none'}} href="https://wa.me/918799778497" target="_blank">+91-8799778497</a></li>
            <li>📧 Email: <a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=support@sattawalaonline.com&su=Support%20Inquiry&body=Hello%20Sattawala%20Team,"
  target="_blank"
  rel="noopener noreferrer"
  style={{ color: "#000", textDecoration: "none" }}
>
  support@sattawalaonline.com
</a></li>
            <li>🌐 Website: <strong> <a style={{color:'#000',textDecoration:'none'}} href="https://sattawalaonline.com/" target="_blank">www.sattawalaonline.com</a> </strong></li>
          </ul>
        </section>

        <section className="contactus-form-section">
          <h2>Send Us a Message</h2>
          <form className="contactus-form">
            <div className="form-group">
              <label>Your Name</label>
              <input type="text" placeholder="Enter your name" required />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input type="email" placeholder="Enter your email" required />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea placeholder="Write your message..." rows="5" required></textarea>
            </div>

            <button type="submit" className="contactus-btn">Send Message</button>
          </form>
        </section>

        {/* ✅ Added WhatsApp section */}
        <section className="contactus-whatsapp">
          <h2>Chat With Us on WhatsApp</h2>
          <p>
            For instant replies, connect with us directly on WhatsApp.  
            Click the button below to start chatting:
          </p>
          <a
            href="https://wa.me/918799778497"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-btn"
          >
            💬 Chat on WhatsApp
          </a>
        </section>
      </div>
    </div>
  );
};

export default ContactUs;
